module.exports = __webpack_public_path__ + "img/spinner.cca9827b.gif";